/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PageReportOut,
  ProblemDetail,
  ReportIn,
  ReportOut,
  ReportsListReportsParams
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Архив отчётов, новые сверху
 */
export const reportsListReports = (
    params?: ReportsListReportsParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<PageReportOut>(
      {url: `/api/v1/reports`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getReportsListReportsQueryKey = (params?: ReportsListReportsParams,) => {
    return [
    `/api/v1/reports`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsListReportsQueryOptions = <TData = Awaited<ReturnType<typeof reportsListReports>>, TError = ErrorType<ProblemDetail>>(params?: ReportsListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsListReports>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsListReportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsListReports>>> = ({ signal }) => reportsListReports(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsListReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsListReportsQueryResult = NonNullable<Awaited<ReturnType<typeof reportsListReports>>>
export type ReportsListReportsQueryError = ErrorType<ProblemDetail>


export function useReportsListReports<TData = Awaited<ReturnType<typeof reportsListReports>>, TError = ErrorType<ProblemDetail>>(
 params: undefined |  ReportsListReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsListReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsListReports>>,
          TError,
          Awaited<ReturnType<typeof reportsListReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsListReports<TData = Awaited<ReturnType<typeof reportsListReports>>, TError = ErrorType<ProblemDetail>>(
 params?: ReportsListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsListReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsListReports>>,
          TError,
          Awaited<ReturnType<typeof reportsListReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsListReports<TData = Awaited<ReturnType<typeof reportsListReports>>, TError = ErrorType<ProblemDetail>>(
 params?: ReportsListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsListReports>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Архив отчётов, новые сверху
 */

export function useReportsListReports<TData = Awaited<ReturnType<typeof reportsListReports>>, TError = ErrorType<ProblemDetail>>(
 params?: ReportsListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsListReports>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsListReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Заказать отчёт за период; файл соберёт воркер, статус — в архиве
 */
export const reportsCreateReport = (
    reportIn: BodyType<ReportIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ReportOut>(
      {url: `/api/v1/reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getReportsCreateReportMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportsCreateReport>>, TError,{data: BodyType<ReportIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof reportsCreateReport>>, TError,{data: BodyType<ReportIn>}, TContext> => {

const mutationKey = ['reportsCreateReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportsCreateReport>>, {data: BodyType<ReportIn>}> = (props) => {
          const {data} = props ?? {};

          return  reportsCreateReport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReportsCreateReportMutationResult = NonNullable<Awaited<ReturnType<typeof reportsCreateReport>>>
    export type ReportsCreateReportMutationBody = BodyType<ReportIn>
    export type ReportsCreateReportMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Заказать отчёт за период; файл соберёт воркер, статус — в архиве
 */
export const useReportsCreateReport = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportsCreateReport>>, TError,{data: BodyType<ReportIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reportsCreateReport>>,
        TError,
        {data: BodyType<ReportIn>},
        TContext
      > => {

      const mutationOptions = getReportsCreateReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Отчёт и его статус
 */
export const reportsGetReport = (
    reportId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ReportOut>(
      {url: `/api/v1/reports/${reportId}`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getReportsGetReportQueryKey = (reportId?: number,) => {
    return [
    `/api/v1/reports/${reportId}`
    ] as const;
    }

    
export const getReportsGetReportQueryOptions = <TData = Awaited<ReturnType<typeof reportsGetReport>>, TError = ErrorType<ProblemDetail>>(reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsGetReport>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsGetReportQueryKey(reportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsGetReport>>> = ({ signal }) => reportsGetReport(reportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsGetReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsGetReportQueryResult = NonNullable<Awaited<ReturnType<typeof reportsGetReport>>>
export type ReportsGetReportQueryError = ErrorType<ProblemDetail>


export function useReportsGetReport<TData = Awaited<ReturnType<typeof reportsGetReport>>, TError = ErrorType<ProblemDetail>>(
 reportId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsGetReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsGetReport>>,
          TError,
          Awaited<ReturnType<typeof reportsGetReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsGetReport<TData = Awaited<ReturnType<typeof reportsGetReport>>, TError = ErrorType<ProblemDetail>>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsGetReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsGetReport>>,
          TError,
          Awaited<ReturnType<typeof reportsGetReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsGetReport<TData = Awaited<ReturnType<typeof reportsGetReport>>, TError = ErrorType<ProblemDetail>>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsGetReport>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отчёт и его статус
 */

export function useReportsGetReport<TData = Awaited<ReturnType<typeof reportsGetReport>>, TError = ErrorType<ProblemDetail>>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsGetReport>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsGetReportQueryOptions(reportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Скачать готовый отчёт (.xlsx)
 */
export const reportsDownload = (
    reportId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<unknown>(
      {url: `/api/v1/reports/${reportId}/file`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getReportsDownloadQueryKey = (reportId?: number,) => {
    return [
    `/api/v1/reports/${reportId}/file`
    ] as const;
    }

    
export const getReportsDownloadQueryOptions = <TData = Awaited<ReturnType<typeof reportsDownload>>, TError = ErrorType<ProblemDetail>>(reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsDownload>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsDownloadQueryKey(reportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsDownload>>> = ({ signal }) => reportsDownload(reportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsDownload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof reportsDownload>>>
export type ReportsDownloadQueryError = ErrorType<ProblemDetail>


export function useReportsDownload<TData = Awaited<ReturnType<typeof reportsDownload>>, TError = ErrorType<ProblemDetail>>(
 reportId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsDownload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsDownload>>,
          TError,
          Awaited<ReturnType<typeof reportsDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsDownload<TData = Awaited<ReturnType<typeof reportsDownload>>, TError = ErrorType<ProblemDetail>>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsDownload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsDownload>>,
          TError,
          Awaited<ReturnType<typeof reportsDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsDownload<TData = Awaited<ReturnType<typeof reportsDownload>>, TError = ErrorType<ProblemDetail>>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsDownload>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Скачать готовый отчёт (.xlsx)
 */

export function useReportsDownload<TData = Awaited<ReturnType<typeof reportsDownload>>, TError = ErrorType<ProblemDetail>>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsDownload>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsDownloadQueryOptions(reportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Пересобрать: новый отчёт за тот же период (после исправлений)
 */
export const reportsRebuild = (
    reportId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ReportOut>(
      {url: `/api/v1/reports/${reportId}/rebuild`, method: 'POST', ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getReportsRebuildMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportsRebuild>>, TError,{reportId: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof reportsRebuild>>, TError,{reportId: number}, TContext> => {

const mutationKey = ['reportsRebuild'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportsRebuild>>, {reportId: number}> = (props) => {
          const {reportId} = props ?? {};

          return  reportsRebuild(reportId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReportsRebuildMutationResult = NonNullable<Awaited<ReturnType<typeof reportsRebuild>>>
    
    export type ReportsRebuildMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Пересобрать: новый отчёт за тот же период (после исправлений)
 */
export const useReportsRebuild = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportsRebuild>>, TError,{reportId: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reportsRebuild>>,
        TError,
        {reportId: number},
        TContext
      > => {

      const mutationOptions = getReportsRebuildMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    